const _map = document.getElementById('map');

if (_map) {
	const latitude = Number(_map.getAttribute('data-latitude'));
	const longitude = Number(_map.getAttribute('data-longitude'));
	  
	window.initMap = function () {
		const map = new google.maps.Map(_map, {
			zoom: 13,
			center: {lat: latitude, lng: longitude},
			mapTypeControl: false,
			streetViewControl: false,
			fullscreenControl: false,
		});

		new google.maps.Marker({
			position: {lat: latitude, lng: longitude},
			map,
		});
		
		const centerControlDiv = document.createElement('div');
		const controlButton = document.createElement('button');

		controlButton.style.backgroundColor = '#fff';
		controlButton.style.border = '2px solid #fff';
		controlButton.style.borderRadius = '2px';
		controlButton.style.boxShadow = '0px 1px 4px -1px rgba(0, 0, 0, 0.3)';
		controlButton.style.color = 'rgb(25,25,25)';
		controlButton.style.cursor = 'pointer';
		controlButton.style.fontFamily = 'Roboto,Arial,sans-serif';
		controlButton.style.fontSize = '16px';
		controlButton.style.lineHeight = '38px';
		controlButton.style.margin = '10px';
		controlButton.style.padding = '0 10px';
		controlButton.style.textAlign = 'center';

		controlButton.textContent = 'Nagyobb térkép';
		controlButton.type = 'button';

		controlButton.addEventListener('click', () => {
			window.open(`http://maps.google.com/maps?q=${latitude},${longitude}`, '_blank');
		});
		
		centerControlDiv.appendChild(controlButton);
		
		map.controls[google.maps.ControlPosition.TOP_LEFT].push(centerControlDiv);
	};
} else {
	window.initMap = function () {};
}